import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { RadioOption, RadioOptionsInput } from "../RadioOptionsInput";
import { EXPORT_INCLUSION_TYPES } from "./types";

interface Props {
  disabled?: boolean;
  dataType: string;
  testIdPrefix?: string;
  options: RadioOption[];
  inclusion: EXPORT_INCLUSION_TYPES;
  children?: ReactNode;
  setInclusion?: (inclusion: EXPORT_INCLUSION_TYPES) => void;
  renderOptionContent?: (optionValue: string, index: number) => ReactNode;
}

export function ExportDataTypeInclusionSelector({
  setInclusion,
  dataType,
  testIdPrefix,
  inclusion,
  options,
  disabled,
  children,
  renderOptionContent,
}: Props) {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={"bold"}>
        What {dataType} would you like to see in the export?
      </Typography>
      <RadioOptionsInput
        baseId={`CompanyListExport-${dataType}SelectType`}
        testIdPrefix={testIdPrefix}
        value={inclusion}
        options={options}
        onChange={(value) => {
          setInclusion?.(
            EXPORT_INCLUSION_TYPES[value as keyof typeof EXPORT_INCLUSION_TYPES]
          );
        }}
        disabled={disabled}
        renderOptionContent={renderOptionContent}
      />
      {children}
    </Box>
  );
}
